import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bengaliMonth',
})
export class BengaliMonthPipe implements PipeTransform {
  transform(value: string): string {
    const banglaMonths = [
      'জানুয়ারি',
      'ফেব্রুয়ারি',
      'মার্চ',
      'এপ্রিল',
      'মে',
      'জুন',
      'জুলাই',
      'আগষ্ট',
      'সেপ্টম্বর',
      'অক্টোবর',
      'নভেম্বর',
      'ডিসেম্বর',
    ];
    const englishMonths = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const index = englishMonths.indexOf(value);
    return index !== -1 ? banglaMonths[index] : value;
  }
}
